export default {
  APPROVAL: '1',
  CORRECTIVE: '4',
  CLOSE: '5',
  SUBMITTING: '0',
  INPROGRESS: '3'
}



// WEBPACK FOOTER //
// ./src/status.js